var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 75,
    viewBox: "0 0 115 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0748 33.3391C75.8644 33.1899 74.6439 33.1314 73.4239 33.1658H70.9731V40.2942H73.7478C75.0971 40.3717 76.4509 40.2393 77.76 39.9022C78.4021 39.6645 78.955 39.2337 79.3434 38.6699C79.731 38.0928 79.9321 37.4112 79.9182 36.7164C79.9489 35.887 79.6615 35.0767 79.1152 34.4521C78.5798 33.8619 77.8609 33.4691 77.0748 33.339L77.0748 33.3391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.9883H114.364V74.0028H0V64.9883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.502 63.2342H6.86182C6.86182 41.0347 21.1243 22.1978 41.0363 15.4706C43.4577 14.6634 46.0143 13.9905 48.7059 13.587C51.5318 13.1834 54.3568 12.9141 57.3168 12.9141C60.2768 12.9141 63.1018 13.1834 65.9277 13.587C68.4843 13.9905 71.0407 14.6635 73.462 15.4706C93.2392 22.1978 107.502 41.0342 107.502 63.2342H107.502Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1958 9.01454C66.1958 10.091 66.0616 11.0323 65.658 11.9745C62.8321 11.571 60.0071 11.3016 57.0471 11.3016C54.0871 11.3016 51.2621 11.571 48.4362 11.9745C48.1669 11.0323 47.8984 10.091 47.8984 9.01454C47.8984 4.0366 51.935 0 56.913 0C62.1593 0 66.1959 4.0366 66.1959 9.01454H66.1958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/OrderIcon.99549d0af8f58c62317652adac8a9455.svg";
export { ForwardRef as ReactComponent };